import { FUTURE, PAST_YEAR, PRESENT, TIMELINE_PATHNAME } from 'timeline/enums/constants';

export const getTimelineTimePeriod = ({ asPath, pathname, query }) => {
  const isTimelinePath = pathname === TIMELINE_PATHNAME;

  if (!isTimelinePath) {
    return null;
  }

  const isPresent = asPath.split('/').length === 2;
  const timelineYear = query?.timelineYear?.[0];

  if (isPresent) {
    return PRESENT;
  }

  if (timelineYear === FUTURE) {
    return FUTURE;
  }

  return PAST_YEAR;
};
